import React from 'react';
import InfoItem from './InfoItem';
import IconItem from './IconItem';

const Savings = ({ p }) => {
  let savings = [];
  if (p.dispensing) {
    savings.push('Medication');
  }
  if (p.labDiscounts) {
    savings.push('Blood tests');
  }
  if (p.radiologyDiscounts) {
    savings.push('Radiology');
  }
  if (savings.length === 0) return null;
  return (
    <InfoItem title="Discounted cash prices">
      {savings.map((ben, i) => (
        <IconItem key={i} icon={'check'}>
          <p>{ben}</p>
        </IconItem>
      ))}
    </InfoItem>
  );
};

export default Savings;
